<template>
  <div>
    <v-row>
      <v-col 
        cols="12" 
        md="8">
        <v-card
          class="border-radius mb-4"
          color="#fff"
          style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
          <v-card-text
            class="py-0">
            <v-row 
              align="center">
              <v-col 
                cols="2"
                class="body-1 font-weight-bold black--text">
                Pengaju / Pelapor:
              </v-col>

              <v-col 
                cols="10">
                <swiper 
                  class="swiper"
                  ref="swiper"
                  :options="{ slidesPerView: 'auto' }">
                  <swiper-slide 
                    v-for="(item, index) in process.user ? 20 : list.user" 
                    :key="index" 
                    :class="index < 1 ? 'pr-3' : index < list.user.length ? 'pr-3' : 'px-3'"
                    style="width: auto;">
                    <v-skeleton-loader
                      class="ma-auto"
                      :loading="process.user"
                      type="avatar"
                      tile>
                      <div>
                        <v-card v-if="!process.user && list.user.length > 0"
                          :to="`/user/${item.id}`"
                          flat
                          color="transparent"
                          class="border-radius d-flex align-center justify-center">
                          <div class="text-center">
                            <v-avatar 
                              size="45" 
                              tile>
                              <v-img 
                                alt="kominfo" 
                                :src="item.image"
                                class="ma-auto"
                                style="border-radius: 10px;">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="white">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
                          </div>
                        </v-card>
                      </div>
                    </v-skeleton-loader>
                  </swiper-slide>

                  <swiper-slide 
                    style="width: auto;">
                    <v-btn
                      to="/user"
                      large
                      color="#ff64ad"
                      class="text-capitalize white--text px-0"
                      min-width="45"
                      min-height="45"
                      style="border-radius: 10px; 
                            box-shadow: rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset;">
                      <v-avatar 
                        color="#ff64ad" 
                        size="30"
                        style="box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;">
                        <v-icon>mdi-arrow-right-thick</v-icon>
                      </v-avatar>
                    </v-btn>
                  </swiper-slide>
                </swiper>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-row>
          <v-col 
            cols="12" 
            md="5">
            <v-card
              class="border-radius mb-6"
              color="#fff"
              style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
              <v-card-text>
                <div
                  class="d-flex align-start">
                  <div>
                    <div class="title black--text font-weight-bold">
                      Total Ajuan
                    </div>

                    <div 
                      class="body-2 d-flex align-center mb-12">
                      <v-icon small>mdi-file-sign</v-icon>
                      
                      <span
                        class="ml-1">
                        Total data ajuan SAKURA
                      </span>
                    </div>
                  </div>

                  <v-spacer />

                  <div>
                    <v-img 
                      width="60"
                      height="60"
                      alt="kominfo" 
                      :src="require(`@/assets/image/time/${isDay}.png`)"
                      class="ma-auto">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="white">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>
                </div>

                <div class="d-flex align-center">
                  <div class="d-flex align-end">
                    <span 
                      class="text-h3 black--text font-weight-bold">
                      {{ list.percent.total | numeric }}
                    </span>

                    <v-icon 
                      size="28" 
                      :color="list.percent.position === 'up' ? 'green' :
                              list.percent.position === 'down' ? 'red' : 'grey'" 
                      class="mb-1">
                      {{ list.percent.position === 'up' ? 'mdi-arrow-up-thick' :
                         list.percent.position === 'down' ? 'mdi-arrow-down-thick' : 'mdi-swap-horizontal'
                      }}
                    </v-icon>

                    <span 
                      class="font-weight-bold mb-1"
                      :class="list.percent.position === 'up' ? 'green--text' :
                              list.percent.position === 'down' ? 'red--text' : 'grey--text'" >
                      {{ list.percent.percent }}%
                    </span>
                  </div>

                  <v-spacer />

                  <div class="black--text">
                    <div v-if="clock.time.length > 0">
                      <div 
                        class="body-2" 
                        style="opacity: 60%;">
                        {{ clock.date | date }}
                      </div>

                      <div 
                        class="title font-weight-bold">
                        {{ clock.time }}
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
            
            <v-card
              class="border-radius pa-4"
              style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
              <v-img 
                width="100"
                height="100"
                alt="vuetify" 
                :src="require('@/assets/image/doc_1.png')"
                class="ma-auto">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#58b1ed">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div class="title color-first font-weight-bold text-center mt-4 mb-2">
                Lembar Kerja
              </div>

              <div
                style="opacity: 60%;">
                <div class="text-center mb-1">
                  Segera proses lembar kerja Anda
                </div>
                
                <div class="text-center">
                  yang masuk ke SAKURA
                </div>
              </div>

              <div class="text-center mt-4 mb-1">
                <v-btn
                  to="/worksheet"
                  rounded
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text pl-3 pr-2"
                  width="200"
                  color="#ff64ad">
                  <div>
                    Lembar Kerja
                  </div>

                  <v-spacer />

                  <div>
                    <v-avatar color="white" size="24">
                      <v-icon size="20" color="#ff64ad">mdi-arrow-right-thick</v-icon>
                    </v-avatar>
                  </div>
                </v-btn>
              </div>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="7">
            <div
              class="mb-3">
              <v-card-text
                class="body-1 font-weight-bold black--text d-flex align-center pa-0 pr-1">
                <span>
                  Layanan Yang Anda Tangani
                </span>

                <v-spacer />

                <router-link
                  to="/worksheet">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </router-link>
              </v-card-text>
              
              <swiper 
                class="swiper"
                ref="swiper"
                :options="{ slidesPerView: 'auto' }">
                <swiper-slide 
                  v-for="(item, index) in process.service ? 10 : list.service" 
                  :key="index" 
                  :class="index < 1 ? 'pl-1 pr-2' : index === list.service.length - 1 ? 'pr-1' : 'px-2'"
                  style="width: auto;">
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.service"
                    type="avatar"
                    tile>
                    <div>
                      <v-card v-if="!process.service && list.service.length > 0"
                        :to="`/worksheet?code=${index}`"
                        width="100"
                        height="100"
                        style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;"
                        color="transparent"
                        class="border-radius d-flex align-center justify-center my-3">
                        <div>
                          <div class="text-center">
                            <v-avatar 
                              size="50" 
                              tile>
                              <v-img 
                                alt="kominfo" 
                                :src="require(`@/assets/image/service/${item.layanan_kode}.png`)"
                                class="ma-auto"
                                style="border-radius: 10px;">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="white">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
                          </div>

                          <div
                            style="font-size: 8px;"
                            class="font-weight-bold text-center mt-2">
                            {{ item.layanan_nama }}
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </v-skeleton-loader>
                </swiper-slide>
              </swiper>
            </div>

            <v-card
              class="border-radius"
              style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
              <v-card-title 
                class="title font-weight-bold black--text">
                Grafik Ajuan
              </v-card-title>

              <v-card-subtitle 
                class="body-2 pb-0 d-flex align-center">
                <v-icon small>mdi-chart-line</v-icon>
                
                <span
                  class="ml-1">
                  Sampai Dengan <b>{{ clock.date | date }}</b>
                </span>
              </v-card-subtitle>

              <v-card-text
                class="pr-2"
                :class="process.graphic ? 'pa-4' : 'pa-0'">
                <v-skeleton-loader
                  class="ma-auto"
                  :loading="process.graphic"
                  type="image">
                  <div>
                    <div v-if="!process.graphic && Object.keys(this.list.bar).length > 0">
                      <apexchart 
                        height="269" 
                        :options="list.bar.chartOptions" 
                        :series="list.bar.series">
                      </apexchart>
                    </div>
                  </div>
                </v-skeleton-loader>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <div class="body-1 font-weight-bold black--text mt-2 mb-3 d-flex align-center">
          Total Produk per {{ clock.date | date }}

          <v-spacer />

          <v-menu
            bottom
            left>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                class="body-2 cursor-pointer blue--text">
                <v-icon>mdi-dots-horizontal</v-icon>
              </div>
            </template>

            <v-list
              dense
              class="py-0">
              <!-- <v-list-item
                v-for="(item, index) in list.service" 
                :key="index" 
                v-if="index < 6"
                :to="`/product?code=${index}`">
                <v-list-item-title>
                  {{ item.layanan_nama }}
                </v-list-item-title>
              </v-list-item> -->

              <v-list-item
                v-for="(item, index) in list.service_product" 
                :key="index" 
                :to="`/product?code=${index}`">
                <v-list-item-title>
                  {{ item.layanan_nama }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-card
          min-height="194"
          class="border-radius d-flex align-center justify-center pa-4"
          style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
          <swiper 
            class="swiper"
            ref="swiper"
            :options="{ slidesPerView: 'auto' }">
            <swiper-slide 
              v-for="(item, index) in process.product ? 7 : list.product" 
              :key="index" 
              class="d-flex align-center justify-center" 
              :class="index < 1 ? 'pr-3' : index < list.product.length ? 'pr-3' : 'px-3'"
              style="width: auto;">
              <v-skeleton-loader
                class="ma-auto mx-3"
                :loading="process.product"
                type="card"
                width="125"
                height="125"
                tile>
                <div>
                  <div v-if="!process.product && list.product.length > 0"
                    class="text-center mx-2"
                    style="width: 100px;">
                    <v-progress-circular
                      :rotate="360"
                      :size="100"
                      :width="15"
                      :value="item.count"
                      :color="item.key === 'diajukan_tte' ? 'cyan' :
                              item.key === 'siap_dicetak' ? 'blue' :
                              item.key === 'sudah_dicetak' ? 'indigo' :
                              item.key === 'siap_diambil' ? 'lime' :
                              item.key === 'sudah_diambil' ? 'purple' :
                              item.key === 'siap_didownload' ? 'green' : ''"
                      class="body-1 font-weight-bold">
                      {{ item.count | numeric }}
                    </v-progress-circular>

                    <div class="body-2 font-weight-bold mt-3"
                      style="height: 40px;">
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </v-skeleton-loader>
            </swiper-slide>
          </swiper>
        </v-card>
      </v-col>

      <v-col 
        cols="12" 
        md="4">
        <v-card
          class="border-radius mb-3"
          color="#fff"
          style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
          <v-card-subtitle
            class="caption pb-0">
            Per {{ clock.date | date }}
          </v-card-subtitle>

          <v-card-title
            class="d-flex align-center pt-0">
            <div
              class="title black--text pt-0">
              Ajuan Pelapor
            </div>

            <v-spacer />

            <v-menu
              bottom
              left>
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  class="body-2 cursor-pointer blue--text">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </div>
              </template>

              <v-list
                dense
                class="py-0">
                <v-list-item
                  v-for="(item, index) in list.service" 
                  :key="index" 
                  :to="`/submission?code=${index}`">
                  <v-list-item-title>
                    {{ item.layanan_nama }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>

          <v-card-text
            class="pb-3 my-2">
            <v-card
              color="#ff64ad"
              class="border-radius"
              style="box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;">
              <v-row
                justify="center">
                <v-col
                  v-for="(item, index) in process.flow ? 3 : list.flow" 
                  :key="index" 
                  cols="4"
                  class="white--text text-center"
                  style="border-right: 1px solid #ffffff26;">
                  <v-skeleton-loader
                    class="ma-auto mx-3"
                    :loading="process.flow"
                    type="card"
                    width="78"
                    height="78"
                    tile>
                    <div>
                      <div v-if="!process.flow && list.flow.length > 0">
                        <div
                          class="caption mb-2">
                          {{ item.name }}
                        </div>

                        <div
                          class="text-h5 font-weight-bold">
                          {{ item.count | numeric }}
                        </div>
                      </div>
                    </div>
                  </v-skeleton-loader>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>

          <v-card-text>
            <div
              class="body-1 font-weight-bold black--text">
              Detail Ajuan
            </div>

            <div
              class="caption">
              <v-icon small>mdi-chart-timeline-variant</v-icon>
              Status Ajuan
            </div>

            <v-row
              justify="center">
              <v-col
                v-for="(item, index) in process.submission ? 4 : list.submission"
                :key="index"
                cols="3">
                <v-skeleton-loader
                  class="ma-auto"
                  :loading="process.submission"
                  type="avatar"
                  tile>
                  <div>
                    <div v-if="!process.submission && list.submission.length > 0">
                      <div
                        class="my-1"
                        style="font-size: 8px;">
                        {{ item.name }}
                      </div>

                      <div
                        class="text-h5 font-weight-bold black--text d-flex align-center">
                        {{ item.count | numeric }}

                        <v-badge 
                          dot 
                          class="ml-1 mb-4" 
                          :color="item.name === 'BELUM DIVERIFIKASI' ? 'orange' :
                                  item.name === 'DITOLAK' ? 'red' :
                                  item.name === 'DISETUJUI' ? 'blue' : 'green'">
                        </v-badge>
                      </div>
                    </div>
                  </div>
                </v-skeleton-loader>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-row>
          <v-col
            cols="12"
            md="6">
            <v-skeleton-loader v-if="Object.keys(list.news).length < 1"
              class="ma-auto"
              height="154"
              :loading="process.news"
              type="card">
            </v-skeleton-loader>
            
            <v-card v-if="Object.keys(list.news).length > 0"
              class="border-radius"
              color="#ff64ad26"
              style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
              <v-card-text
                class="pb-0 d-flex align-start">
                <v-avatar 
                  tile
                  size="75">
                  <v-img
                    style="border-radius: 10px;"
                    alt="vuetify"
                    :src="list.news.content[0].post_image[0].url">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          color="#ff64ad">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <v-spacer />

                <div v-if="list.news.content.length > 0"
                  style="position: relative; top: -5px; right: -1px;">
                  <v-btn
                    :to="`/news/${list.news.content[0].id}`"
                    icon
                    x-small>
                    <v-icon size="20" color="blue">mdi-information</v-icon>
                  </v-btn>
                </div>

                <div v-else
                  style="position: relative; top: -5px; right: -1px;">
                  <v-btn
                    to="/news"
                    icon
                    x-small>
                    <v-icon size="20" color="red">mdi-information</v-icon>
                  </v-btn>
                </div>
              </v-card-text>

              <v-card-title
                class="body-2 font-weight-bold black--text pt-2">
                <span
                  class="one-line">
                  {{ list.news.content.length > 0 ? list.news.content[0].post_title : 'Belum Ada Berita' }}
                </span>
              </v-card-title>

              <v-card-subtitle
                class="caption font-weight-light">
                <div
                  class="one-line">
                  <span v-if="list.news.content.length > 0"
                    v-html="list.news.content[0].post_content">
                  </span>

                  <span v-else>
                    Silahkan buat berita untuk content SAKURA
                  </span>
                </div>
              </v-card-subtitle>
            </v-card>
          </v-col>

          <v-col
            v-for="(item, index) in process.news ? 2 : list.news.list"
            :key="index"
            cols="3">
            <v-skeleton-loader
              class="ma-auto"
              height="154"
              :loading="process.news"
              type="card">
              <div>
                <v-card v-if="!process.news && list.news.list.length > 0"
                  min-height="155"
                  class="border-radius"
                  color="#fff"
                  style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
                  <v-card-text
                    class="text-center pb-2">
                    <v-avatar
                      :color="item.name === 'DRAFT' ? 'orange' : 'green'"
                      large>
                      <v-icon size="28" color="white">
                        {{ item.name === 'DRAFT' ? 'mdi-progress-clock' : 'mdi-newspaper-check' }}
                      </v-icon>
                    </v-avatar>
                  </v-card-text>

                  <v-card-text
                    class="text-center pb-0">
                    <div>
                      {{ item.name }}
                    </div>

                    <div
                      class="text-h5 font-weight-bold black--text">
                      {{ item.count }}
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-skeleton-loader>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            v-for="(item, index) in process.user_count ? 4 : list.user_count"
            :key="index"
            cols="12"
            md="6">
            <v-skeleton-loader
              class="ma-auto"
              height="130"
              :loading="process.user_count"
              type="card">
              <div>
                <v-card v-if="!process.user_count && list.user_count.length > 0"
                  class="border-radius"
                  color="#fff"
                  style="box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;">
                  <v-card-text
                    class="d-flex justify-start pb-3">
                    <div
                      class="d-flex align-center">
                      <v-img
                        contain
                        width="25"
                        height="25"
                        alt="vuetify"
                        :src="item.type === 'user' ? require('@/assets/image/user/user.png') :
                              item.type === 'perantara' ? require('@/assets/image/user/team.png') :
                              item.type === 'operator' ? require('@/assets/image/user/group.png') : 
                              require('@/assets/image/user/admin.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="#ff64ad">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      
                      <span
                        class="body-1 font-weight-bold ml-2 black--text">
                        {{
                          item.type === 'user' ? 'Pengguna' :
                          item.type === 'perantara' ? 'Petugas Registrasi' :
                          item.type === 'operator' ? 'Operator' : 'Superadmin'
                        }}
                      </span>
                    </div>
                  </v-card-text>
                  
                  <v-card-text
                    class="d-flex align-end">
                    <div
                      class="text-h5 font-weight-bold black--text">
                      {{ item.count | numeric }}
                    </div>

                    <v-spacer />

                    <div
                      class="caption font-weight-light">
                      <div v-if="!process.user_count && list.user_count.length > 0 && item.list.length > 0"
                        class="mb-1 d-flex align-center">
                        <div
                          v-for="(item_img, index_img) in item.list"
                          :key="index_img">
                          <v-avatar v-if="index_img < 3"
                            size="24"
                            style="border: 2px solid #fff; position: relative;"
                            :style="index_img === 1 ? 'left: -5px;' : 
                                    index_img === 2 ? 'left: -10px;' : ''">
                            <v-img
                              width="24"
                              height="24"
                              alt="vuetify"
                              :src="item_img.image">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="#ff64ad">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>
                        </div>

                        <router-link
                          :to="`/${item.type === 'user' || item.type === 'perantara' ? 'user' : 'admin' }?type=${item.type}`">
                          <v-avatar
                            size="24"
                            color="#ff64ad"
                            style="border: 2px solid #fff; position: relative;"
                            :style="item.list.length === 1 ? 'left: -5px;' : 
                                    item.list.length === 2 ? 'left: -10px;' : 'left: -15px;'">
                            <v-icon small color="white">mdi-plus</v-icon>
                          </v-avatar>
                        </router-link>
                      </div>

                      per <b>{{ clock.date | date }}</b>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },
        clock: {
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          time: ''
        },
        list: {
          percent: {
            total: 0,
            position: 'up',
            percent: 0
          },
          user: [],
          service: [],
          service_product: [],
          flow: [],
          submission: [],
          news: {},
          product: [],
          bar: {},
          user_count: []
        },
        pagination: {
          user: {}
        },
        process: {
          percent: false,
          user: false,
          service: false,
          service_product: false,
          flow: false,
          submission: false,
          news: false,
          product: false,
          graphic: false,
          user_count: false
        }
      }
    },
    components: {
      
    },
    computed: {
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      }
    },
    watch: {
      
    },
    mounted () {
      this.fetch()

      // let kemarin = 1000, sekarang = 1002, status = '', persen = 0

      // let jumlah = sekarang - kemarin

      // if (jumlah === 0) {
      //   persen = 0
      //   status = 'midle'
      // } else if (jumlah < 0) {
      //   persen = (jumlah / kemarin) * 100
      //   status = 'down'
      // } else if (jumlah > 0) {
      //   persen = (jumlah / kemarin) * 100
      //   status = 'up'
      // }

      // console.log(jumlah, persen, status)
    },
    methods: {
      fetch () {
        setInterval(this.updateTime, 1000)

        this.fetchPercent()
        this.fetchUser()
        this.fetchService()
        this.fetchServiceProduct()
        this.fetchFlow()
        this.fetchSubmission()
        this.fetchNews()
        this.fetchProduct()
        this.fetchGraphic()
        this.fetchUser_Count()
      },
      async fetchPercent () {
        this.process.percent = true

        await get('dashboard/ajuan_count_percent')
        .then(response => {
          let res = response.data

          this.process.percent = false
            
          if (res.code === 200) {
            this.list.percent = res.data
          }
        })
      },
      async fetchUser () {
        this.process.user = true

        let params = {
          limit: 20
        }

        await get('user', { params })
        .then(response => {
          let res = response.data

          this.process.user = false
            
          if (res.code === 200) {
            this.list.user = res.data
            this.pagination.user = res.pagination
          }
        })
      },
      async fetchService () {
        this.process.service = true

        let params = {
          order_by: 'ASC',
          list_type: 'short',
          auth_role: 1
        }

        await get('layanan', { params })
        .then(response => {
          let res = response.data

          this.process.service = false

          if (res.code === 200) {
            this.list.service = res.data
          }
        })
      },
      async fetchServiceProduct () {
        this.process.service_product = true

        let params = {
          order_by: 'ASC',
          list_type: 'short',
          auth_role: 1
        }

        await get('layanan/produk', { params })
        .then(response => {
          let res = response.data

          this.process.service_product = false

          if (res.code === 200) {
            this.list.service_product = res.data
          }
        })
      },
      async fetchFlow () {
        this.process.flow = true

        await get('dashboard/all_data_layanan_flow_count')
        .then(response => {
          let res = response.data

          this.process.flow = false

          if (res.code === 200) {
            this.list.flow = res.data.list
          }
        })
      },
      async fetchSubmission () {
        this.process.submission = true

        await get('dashboard/ajuan_status_count')
        .then(response => {
          let res = response.data

          this.process.submission = false

          if (res.code === 200) {
            this.list.submission = res.data.list
          }
        })
      },
      async fetchNews () {
        this.process.news = true

        await get('dashboard/news_status_count')
        .then(response => {
          let res = response.data

          this.process.news = false

          if (res.code === 200) {
            this.list.news = res.data
          }
        })
      },
      async fetchProduct () {
        this.process.product = true

        await get('dashboard/produk_status_count')
        .then(response => {
          let res = response.data

          this.process.product = false

          if (res.code === 200) {
            this.list.product = res.data.list
          }
        })
      },
      async fetchGraphic () {
        this.process.graphic = true

        await get('dashboard/graphic_ajuan_status_data')
        .then(response => {
          let res = response.data

          this.process.graphic = false

          if (res.code === 200) {
            this.list.bar = {
              series: res.data.graphic_data,
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: false
                },
                colors: ['#FF9800', '#00BCD4', '#9C27B0', '#F44336', '#2196F3', '#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: res.data.month
                }
              }
            }
          }
        })
      },
      async fetchUser_Count () {
        this.process.user_count = true

        await get('dashboard/user_list')
        .then(response => {
          let res = response.data

          this.process.user_count = false

          if (res.code === 200) {
            this.list.user_count = res.data
          }
        })
      },
      updateTime () {
        let cd = new Date()

        this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
      },
      zeroPadding (num, digit) {
        let zero = ''

        for(let i = 0; i < digit; i++) {
          zero += '0'
        }
        return (zero + num).slice(-digit)
      }
    }
  }
</script>